/**
 * UAVTradeZone - Notifications Service
 * Date: 2026-02-09
 *
 * Client service for fetching and managing in-app notifications.
 */

import axios from "axios";
import { apiUrl } from "../config/environment";
import { getAuthHeaders } from "../utils/authUtils";
import {
  NotificationsResponse,
  NotificationCountResponse,
} from "../interfaces/notification";

const notificationsApi = `${apiUrl}/api/notifications`;

/**
 * Fetch paginated notifications for the current user
 * @param page - Page number (0-indexed)
 * @param limit - Items per page (max 50)
 */
export async function fetchNotifications(
  page: number = 0,
  limit: number = 20
): Promise<NotificationsResponse> {
  const response = await axios.get<NotificationsResponse>(notificationsApi, {
    params: { page, limit },
    ...getAuthHeaders(),
  });
  return response.data;
}

/**
 * Fetch count of new (undismissed) notifications
 */
export async function fetchNotificationCount(): Promise<NotificationCountResponse> {
  const response = await axios.get<NotificationCountResponse>(
    `${notificationsApi}/count`,
    getAuthHeaders()
  );
  return response.data;
}

/**
 * Dismiss all notifications for the current user
 */
export async function dismissAllNotifications(): Promise<void> {
  await axios.post(
    `${notificationsApi}/dismiss-all`,
    {},
    getAuthHeaders()
  );
}
